export default "__VITE_ASSET__Zh3rjlH3__"